import { addDays, compareAsc } from 'date-fns';

import {
  mixpanelDataMaskingFieldList,
  WebinarDayWithSlotFieldOptionType
} from '@nw/shared/config';

import { EMOJI_REGEX_PATTERN } from '../../constants/ValidationRegex';

export const getFilteredOptions = (
  options: Array<WebinarDayWithSlotFieldOptionType>,
  dependentFieldValue: string
) => {
  return options.filter((eachOption) =>
    eachOption.match_keys.includes(dependentFieldValue)
  );
};

export const getPreferredDates = (minDate: string, maxDate: string): Date[] => {
  const preferredDates: Date[] = [];
  let date = eval(minDate);
  const maximumDate = new Date(eval(maxDate));
  while (compareAsc(date, maximumDate) !== 0) {
    preferredDates.push(date);
    date = new Date(addDays(date, 1));
  }
  preferredDates.push(maximumDate);
  return preferredDates;
};

export const removeEmojisFromString = (text: string): string => {
  return text.replace(EMOJI_REGEX_PATTERN, '');
};

export const shouldEnableDataMaskBasedOnField = (field): boolean => {
  if (mixpanelDataMaskingFieldList.includes(field)) {
    return true;
  }
  return false;
};

export const removeEmojisFromObject = (obj) => {
  let updatedObj = obj;
  for (const key in updatedObj) {
    if (typeof updatedObj[key] === 'string') {
      updatedObj[key] = removeEmojisFromString(updatedObj[key]);
    }
  }
  return updatedObj;
};

export const sanitizeEmojisFromPayload = <T>(payload: T): T => {
  if (payload == null) {
    return payload;
  }
  if (typeof payload === 'string') {
    return removeEmojisFromString(payload) as unknown as T;
  }
  if (Array.isArray(payload)) {
    return payload.map((eachValue) =>
      sanitizeEmojisFromPayload(eachValue)
    ) as unknown as T;
  }
  if (typeof payload === 'object') {
    const sanitizedPayload: Record<string, any> = {};
    Object.keys(payload as Record<string, any>).forEach((key) => {
      sanitizedPayload[key] = sanitizeEmojisFromPayload(
        (payload as Record<string, any>)[key]
      );
    });
    return sanitizedPayload as T;
  }
  return payload;
};
